module.exports = __webpack_public_path__ + "b2df8246469f9872a5b56f23a2fa1fc3.svg";